module.exports = __webpack_public_path__ + "img/gstarColored.603762ce.svg";